import React from 'react';
import Page from '../../components/Page';
import { PaymentsDetails } from '../../sections/client-zs/PaymentsDetails';

const Payments = () => (
  <Page title="Płatności">
    <PaymentsDetails />
  </Page>
);

export default Payments;
